import { isRouteMenuPoint, MenuPoint, NavColor, NavColors } from '@agilox/ui-common';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DividerComponent } from '../divider/divider.component';
import { TagComponent } from '../tag/tag.component';
import { IconModule } from '../icon/icon.module';

@Component({
	selector: 'ui-mobile-sub-nav-list-entry',
	imports: [IconModule, DividerComponent, TagComponent, NgClass, NgTemplateOutlet, RouterLink],
	templateUrl: './mobile-sub-nav-list-entry.component.html',
})
export class MobileSubNavListEntryComponent {
	item = input<MenuPoint | undefined>();
	isSubmenuOpen = input<boolean>(false);
	currentUrl = input<string>('');
	navColor = input<NavColor>(NavColors.Dark);

	clicked = output<MenuPoint>();

	isRouteItem(item: MenuPoint): boolean {
		return isRouteMenuPoint(item);
	}

	onClick() {
		if (this.item() !== undefined && this.item() !== null && !this.item()?.disabled) {
			this.clicked.emit(this.item() as MenuPoint);
		}
	}

	onClickSubMenu(item: MenuPoint): void {
		if (!item.disabled) {
			this.clicked.emit(item);
		}
	}

	getVisibleSubmenus(item: MenuPoint) {
		return item.submenus?.filter((submenu) => !submenu.hidden);
	}

	isSubmenuActive(subMenuItem: MenuPoint): boolean {
		if (subMenuItem.callback) {
			return false;
		}
		if (subMenuItem.active) {
			return true;
		}
		if (!subMenuItem.url) {
			return false;
		}
		// Exact match so e.g. the overview ("/boards") isn't highlighted on a board page ("/boards/<id>").
		return this.currentUrl().split('?')[0] === subMenuItem.url;
	}
}
